// https://developers.google.com/maps/documentation/urls/guide
import { stringify } from 'querystring';
import typeCheck from 'common/util/typeCheck';

const GOOGLE_MAPS_DIR_URL = 'https://www.google.com/maps/dir/?';

export default function getGoogleMapsDirectionsUrl({ directions, isIphoneApp }) {
  typeCheck('directions::NonEmptyArray', directions);

  const query = {
    api: 1,
    travelmode: 'driving',
  };

  if (directions.length === 1) {
    query.destination = directions[0];
  } else {
    query.origin = directions[0];
    query.destination = directions[directions.length - 1];
  }

  if (directions.length > 2) {
    query.waypoints = directions.slice(1, directions.length - 1).join('|');
  }

  // https://developers.google.com/maps/documentation/urls/ios-urlscheme
  if (isIphoneApp && directions.length === 1) {
    return (
      'comgooglemapsurl://?' +
      stringify({
        daddr: directions[0],
        directionsmode: 'driving',
      })
    );
  }

  return GOOGLE_MAPS_DIR_URL + stringify(query);
}
